// extracted by mini-css-extract-plugin
export default {"popup":"MezzaApproveUpdater_popup__jEnco"};